import {InputText} from '@/components/Form/index.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBms} from '../BM/FormChooseBm.jsx'
import {FormItemFms} from '../FM/FormChooseFm.jsx'
import {FormItemSs} from '../SS/FormChooseSs.jsx'
import Model from './ModelUi.mjs'

export const FormItemUiName = props => (
    <FormItemBizProp
        Model={Model}
        prop="uiName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemUiUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="uiUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseUi(props) {
    const map = useMapContext()
    const {prjTypeCode} = map.data

    return (
        <FormChooseDesign {...props}>
            {'BM' === prjTypeCode ? <FormItemBms /> : <FormItemFms />}
            <FormItemSs />
            <FormItemUiUserCode />
            <FormItemUiName />
        </FormChooseDesign>
    )
}
